import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { handleRemoveQuestion } from "../../../../ducks/questionLibrary";
import { cleanText, QuestionIcon } from "../../../../utils/QuestionUtils";
import TrashButton from "../../../common/TrashButton";
import LibrarySavedAt from "../../../common/LibrarySavedAt";
import LibraryOrigin from "../../../common/LibraryOrigin";
import LibraryTable from "../../../common/LibraryTable";
import questionTypes from "../toolbox/questionTypes";

const columns = [
  {
    key: "type",
    label: "survey.editor.add.question.question.type",
    compact: true,
    value: (item) => item.question.type
  },
  { key: "name", label: "library.elementTitle", value: (item) => cleanText(item.name) },
  {
    key: "origin",
    label: "library.origin",
    value: (item) => `${item.surveyOrigin || ""} ${item.surveyOriginVersion ?? ""}`
  },
  {
    key: "updated",
    label: "library.savedAt",
    compact: true,
    value: (item) => (item.updated == null ? 0 : new Date(item.updated).getTime())
  }
];

const AddQuestionFromLibraryTable = ({
  addQuestionToTemplate,
  questionLibrary = [],
  questionsToAdd = [],
  surveyQuestionIds = []
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const localizedColumns = columns.map((column) =>
    column.key === "type"
      ? { ...column, value: (item) => intl.formatMessage({ id: `question.library.language.${item.question.type}` }) }
      : column
  );
  return (
    <LibraryTable
      items={questionLibrary}
      columns={localizedColumns}
      renderRow={(question) => (
        <tr key={question.id}>
          <td>
            <Form.Check
              type="checkbox"
              id={`library-question-${question.id}`}
              aria-label={question.name}
              checked={questionsToAdd.some((item) => item.id === question.id)}
              onChange={(event) => addQuestionToTemplate(question, event.target.checked)}
              disabled={surveyQuestionIds.includes(question.id)}
            />
          </td>
          <td>
            {questionTypes
              .filter((type) => type.type === question.question.type)
              .map((type) => (
                <QuestionIcon
                  key={type.type}
                  title={intl.formatMessage({ id: type.toolboxComponent })}
                  type={type.type}
                />
              ))}
          </td>
          <td>{question.name}</td>
          <td>
            <LibraryOrigin name={question.surveyOrigin} version={question.surveyOriginVersion} />
          </td>
          <td className="text-nowrap">
            <LibrarySavedAt value={question.updated} />
          </td>
          <td>
            <TrashButton onClick={() => dispatch(handleRemoveQuestion(question))} titleId="library.delete" />
          </td>
        </tr>
      )}
    />
  );
};

AddQuestionFromLibraryTable.propTypes = {
  questionLibrary: PropTypes.array,
  questionsToAdd: PropTypes.array,
  surveyQuestionIds: PropTypes.array,
  addQuestionToTemplate: PropTypes.func
};

export default AddQuestionFromLibraryTable;
